import { FileState } from "@/@types/vuex";

export default {
  filesInfo: {},
} as FileState;
